var t=/Android/i,n=e=>t.test(e);

export { n as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-4XBKAXHQ.js.map